<div class="content">
    <div class="row">
        <div class="col col-md-12 p-0 done">
            <h3 class="col-12">
                This is how we feel about welcoming you to Verve!
            </h3>
            <div class="privacy d-flex gif col-12">
                <div class="done-gif-container">
                    <img class="done-gif" src="https://vervassets.blob.core.windows.net/web/join-form-spice-girls.webp"
                        loading="lazy" />
                </div>
                <div class="flex-fill pl-3 next">
                    <h3 class="whatsnext">So what's next?</h3>
                    <div class="d-flex">
                        <img src="https://vervassets.blob.core.windows.net/web/nmj-icon4.png" loading="lazy"
                            class="icon icon1" />
                        <p>
                            An email has just arrived in your inbox with
                            instructions on how to login to your account
                            and sort out your insurances.
                        </p>
                    </div>
                    <div class="d-flex">
                        <img src="https://vervassets.blob.core.windows.net/web/nmj-icon2.png" loading="lazy"
                            class="icon icon2" />
                        <p>
                            In just a few minutes you’ll get an email on
                            how to start building your super savings.
                            This includes an email to forward to your
                            employer/s (if you have one).
                        </p>
                    </div>
                    <div class="d-flex">
                        <img src="https://vervassets.blob.core.windows.net/web/nmj-icon1.png" loading="lazy"
                            class="icon icon3" />
                        <p>
                            Don’t be a stranger.
                            <a class="contact-us" href="https://vervesuper.com.au/contact-us/" target="_blank">Contact
                                us</a>, if you have any questions.
                        </p>
                    </div>
                </div>
            </div>
            <div class="privacy col-12">
                <div class="keep-touch d-flex align-items-center">
                    <h4 class="flex-fill mb-0">
                        Let's keep in touch
                        <img src="https://vervassets.blob.core.windows.net/web/nmj-icon3.png" loading="lazy"
                            class="icon icon3" />
                    </h4>
                    <div class="social">
                        <a class="no-text-decoration" href="https://www.instagram.com/verve.super" target="_blank"><img
                                loading="lazy"
                                src="https://vervassets.blob.core.windows.net/web/nmj-linkedin.png" /></a>

                        <a class="no-text-decoration" href="https://www.facebook.com/vervesuper/" target="_blank"><img
                                loading="lazy"
                                src="https://vervassets.blob.core.windows.net/web/nmj-facebook.png" /></a>

                        <a class="no-text-decoration" href="https://twitter.com/vervesuper" target="_blank"><img
                                loading="lazy" src="https://vervassets.blob.core.windows.net/web/nmj-twitter.png" /></a>
                    </div>
                </div>
            </div>
            <div class="footer footer-mobile mt-5 col-12">
                <ng-template class="" [ngTemplateOutlet]="FooterStep7"></ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template #FooterStep7>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>